import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'underscore';
import { message } from 'antd';
import Api from '../../../../api/Api';
import { QUERY_KEYS } from '../../../../queries/queryKeys';
import moment from 'moment';
import { tryFormatDate } from '../../../../utils/tryFormatDate';
import { DTFullFormat } from '../../../../utils/StaticVariable';

export const useDatasetPrice = (
  datasetId: string,
  dates?: [moment.Moment, moment.Moment] | undefined
) => {
  const startDate = dates ? tryFormatDate(dates[0], DTFullFormat) : undefined;
  const endDate = dates ? tryFormatDate(dates[1], DTFullFormat) : undefined;

  const priceQuery = useQuery({
    queryKey: [QUERY_KEYS.dataset.price, datasetId, startDate, endDate],
    queryFn: async () => {
      if (isEmpty(datasetId) && !startDate && !endDate) {
        return null;
      }

      const response = await Api.price.GetDatasetPriceByPeriod(
        datasetId,
        startDate!,
        endDate!
      );

      if (
        response?.Result?.Price !== undefined &&
        response?.Result?.Price !== null
      ) {
        return response.Result.Price;
      }

      if (response?.Error) {
        const errorMessage =
          response.Error.ErrorMessage ?? 'Failed to calculate the price';
        message.error(errorMessage);
      }

      return 999;
    },
    enabled: !!datasetId && !!startDate && !!endDate,
    retry: 3,
  });

  return {
    price: priceQuery.data ?? 999,
    priceLoading: priceQuery.isLoading,
    isError: priceQuery.isError,
    error: priceQuery.error,
  };
};
